import React from "react";
import { Link } from "react-router-dom";

function Milestone({ milestone, no }) {
  return (
    <Link className="milestone" to={`/${milestone.toLowerCase()}`}>
      <div>{no}</div>
      <div>/</div>
      <div>{milestone}</div>
    </Link>
  );
}

export default Milestone;
